import React from "react";
import usePatchHook from "../../customHooks/usePatchHook";
import { useParams } from "react-router-dom";
import loadable from "@loadable/component";
import useGetHook from "../../customHooks/useGetHook";
import { tw } from "@careinfo/tailwind";
import Spinner from "../../components/Reusable/Spinner";
import usePostHook from "../../customHooks/usePostHook";
import APIS from "../../constant/Endpoint";
import CreateIcon from "../../Icons/CreateIcon";
import useDailyNotePatch from "../../customHooks/useDailyNotePatch";
const EditDailyNoteComponent = loadable(
  () => import("../../components/DailyNote/SwitchTab")
);

const EditDailyNote = () => {
  const { id } = useParams();
  const { mutateAsync, isPending: isLoading } = useDailyNotePatch();

  const { data, isLoading: isDataLoading } = useGetHook({
    queryKey: ["daily-note", `daily-note-${id}`],
    url: `${APIS.DAILY_NOTE}${id}/`,
    params: {},
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.DAILY_NOTE}${id}/`;
    let formData = {
      ...values,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Daily Note
        </span>
      </div>
      {isDataLoading ? (
        <Spinner />
      ) : (
        <EditDailyNoteComponent
          handleEdit={handleEdit}
          isLoading={isLoading}
          data={data}
          id={id}
        />
      )}
    </>
  );
};

export default EditDailyNote;

